<template lang="pug">
div
  //- Title
  .d-flex.align-center
    v-icon.mr-3(size="18") $yzi-user-circle
    .text-md.font-semibold {{ $t('provider') }}
  v-divider.mt-2.mb-4.neutral500
  //- Content
  v-row.mb-2(no-gutters)
    v-col(cols="2")
      .text-sm.font-semibold {{ $t('doctor') }}
    v-col.text-left
      .d-flex
        .text-sm.font-semibold.mr-3 :
        .text-sm {{ providerName || '-' }}
</template>

<script>

export default {
  props: {
    providerName: {
      type: String,
      default: null
    },
  },
}
</script>

<style lang="scss" scoped>
</style>